import PropTypes from 'prop-types';
import React, {useContext, useEffect, useRef, useState} from 'react';

import Select, {SelectItem} from '../ui/Select';
import ApplicationContext from "../ApplicationContext";
import {BankParams} from "../fms.core/constants";
import useSystemSettings from '../hooks/useSystemSettings';

const BadBankName = 'BAD AR BANK';

interface IBank {
  bankName: string;
  bankNameWithCur: string;
  bankAcc: string;
  currency: string;
  id: number;
  defaultBank: boolean,
  rGlNo:string,
  //
  ediType: string ,
  ediDateColumn: number,
  ediDateFormat: string ,
  ediAmtColumn: number ,
  ediChkNegative: number,
  ediChkNoColumn: number ,
  ediChkCondi: string ,
  ediChkCondiCol: number,
  ediStartRow: number,
}

function BankDropDown({
  value,
  onChange = () => {},
  disabled = false,
  selectId,
  autoSetDefault = false,
  noBadBank = false,
  localBank = false,
  placeholder = undefined,
  currencyBank = undefined,
  name = undefined,
}: {
  value: number | null | undefined,
  disabled?: boolean,
  onChange?: (x: IBank | null) => void,
  selectId?: string,
  autoSetDefault?: boolean,
  noBadBank?: boolean,
  localBank?: boolean,
  placeholder?: string|undefined,
  currencyBank? : string|undefined,
  name?: string|undefined,
}) {
  const appContext = useContext(ApplicationContext);
  const systemSettings = useSystemSettings();
  const primaryCurrency = systemSettings.primaryCurrency ?? 'USD';
  
  const [data, _setData] = useState<Array<IBank>>([]);
  const dataRef = useRef<Array<IBank>>([]);

  function setData(d: Array<IBank>) {
    dataRef.current = d;
    _setData(d);
  }

  async function fetchData(api: any) {
    const data = await api.loadCodeData([new BankParams()]);

    if (data && data.length > 0) {
      setData(noBadBank
        ? (localBank ? data[0].items.filter((x:IBank) => x.bankName !== BadBankName && x.currency === primaryCurrency) : data[0].items.filter((x:IBank) => x.bankName !== BadBankName))
        : (localBank ? data[0].items.filter((x:IBank) => x.currency === primaryCurrency) : data[0].items)
      );

      if (currencyBank) {
        setData(data[0].items.filter((x:IBank) => x.currency === currencyBank));
      }

      if (autoSetDefault && (value === null || value === undefined || value === 0)) {
        const defaultBank = data[0].items.find((x:IBank) => x.defaultBank);
        if (defaultBank) {
          onChange(defaultBank);
        }
      }
    }
  }

  useEffect(() => {
      fetchData(appContext.api);
      return () => {_setData([]);}
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (!e.target.value) {
      const defaultBank = dataRef.current?.find((x:IBank) => x.defaultBank);
      if(autoSetDefault && defaultBank){
        e.target.value = defaultBank?.id.toString()??''; 
      } else{
        e.target.value = dataRef.current[0].id.toString()??'';
      }
    }
    onChange(dataRef.current?.find(d => d.id === Number(e.target.value)) || null);
  }

  const displayData: Array<SelectItem> = [
    ...data.map(x => ({value: x.id ?? 0, label: x.bankNameWithCur ?? ''}))
  ];

  return (
    <Select
      selectId={selectId}
      name={name}
      value={(value === null || value === undefined) ? '' : Number(value)}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
      placeholder={placeholder}
    />
  );
}

BankDropDown.defaultProps = {
  onChange: () => {
  },
  disabled: false,
  dark: false,
  autoSetDefault: false,
  noBadBank: false,
  localBank: false,
};

BankDropDown.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  selectId: PropTypes.string,
  autoSetDefault: PropTypes.bool.isRequired,
  noBadBank: PropTypes.bool.isRequired,
  localBank: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
};

export default React.memo(BankDropDown);
